import React from 'react'
import { useTranslation } from 'lib/i18n'

import Heading from 'components/Heading/Heading'
import Wrapper from 'components/Wrapper/Wrapper'

import styles from './ProfileStepsSection.module.css'

export default function ProfileStepsSection({ color }) {
  const { t } = useTranslation()

  return (
    <section className={styles.stepsSection} style={{ color }}>
      <Wrapper>
        <ol className={styles.profileSteps}>
          <li className={styles.profileStepsItem}>
            <span className={styles.stepCount}>1</span>
            <div>
              <Heading level="h5" className={styles.heading}>
                <h5>
                  {t('profileStepsSection.step1.heading', 'Create your order')}
                </h5>
              </Heading>
              <p>
                {t(
                  'profileStepsSection.step1.text',
                  'Describe what you want to include in your video',
                )}
              </p>
            </div>
          </li>
          <li className={styles.profileStepsItem}>
            <span className={styles.stepCount}>2</span>
            <div>
              <Heading level="h5" className={styles.heading}>
                <h5>
                  {t(
                    'profileStepsSection.step2.heading',
                    'Personalised recording',
                  )}
                </h5>
              </Heading>
              <p>
                {t(
                  'profileStepsSection.step2.text',
                  'The celebrity records your personalised video',
                )}
              </p>
            </div>
          </li>
          <li className={styles.profileStepsItem}>
            <span className={styles.stepCount}>3</span>
            <div>
              <Heading level="h5" className={styles.heading}>
                <h5>
                  {t('profileStepsSection.step3.heading', 'Share the joy')}
                </h5>
              </Heading>
              <p>
                {t(
                  'profileStepsSection.step3.text',
                  'Gift the video, or give it to yourself, you choose.',
                )}
              </p>
            </div>
          </li>
        </ol>
      </Wrapper>
    </section>
  )
}
